import React, { ReactNode } from 'react';
import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';

type CAppTitleProps = {
	id?: string;
	title: string | ReactNode;
	subtitle?: string | ReactNode;
};

const CAppTitle = (props: CAppTitleProps) => {
	const { id, title, subtitle } = props;

	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

	const subtitleComponent = (
		<span
			style={{
				display: 'inline-block',
				lineHeight: '1.5',
				fontSize: '1rem',
				fontFamily: '"Cambo", Arial, Helvetica, sans-serif',
				fontWeight: 'normal',
				alignItems: 'center',
			}}
		>
			{subtitle}
		</span>
	);
	return (
		<Typography id={id} variant="h1" component="h1" style={{ marginTop: '0px', marginBottom: '14px' }}>
			{isMobile ? <Box>{subtitleComponent}</Box> : ''}
			{title} {!isMobile ? subtitleComponent : ''}
		</Typography>
	);
};

export default CAppTitle;
